export default __webpack_public_path__ + "static/media/how_it_works_illustration.18a0b4b3.png";